import React from 'react'
import { Row, Col, Button, } from 'reactstrap'
import { Link, } from 'react-router-dom'

export default function ItemBasicNavMath(props) {
  let previousItem, nextItem, modalQuery = ''
  if (props.itemNumber) {
    previousItem = parseInt(props.itemNumber, 10) - 1
    nextItem = parseInt(props.itemNumber, 10) + 1
  } else {
    previousItem = 'overview'
    nextItem = 2
  }
  if (previousItem === 0) {
    previousItem = props.completed ? 'overview' : props.itemNumber
  }
  if (!props.completed && nextItem > props.lastItemNumber) {
    nextItem = props.itemNumber
    modalQuery = '&m=submit'
  } else if (nextItem > props.lastItemNumber) {
    nextItem = 'overview'
  }
  let prevLink = `?item=${previousItem}`
  let nextLink = `?item=${nextItem}${modalQuery}`
  let studentAdd = ''
  if (props.selectedStudent) {
    studentAdd = `&s=${props.selectedStudent}`
  }
  if (props.isGroup && props.assessmentId) {
    prevLink = `${prevLink}&g=true&a=${props.assessmentId}${studentAdd}`
    nextLink = `${nextLink}&g=true&a=${props.assessmentId}${studentAdd}`
  }
  const SUBMIT = <span style={{writingMode: "vertical-lr",textOrientation: 'upright',fontSize:'9px'}} >SUBMIT</span>

  let comp = (
    <Row>
      <Col sm='6' xl='6'>
        <Link to={prevLink} className='m2no-decoration'><Button className='btn-block' outline>{previousItem === 'overview' ? '<< Overview' : '<< Previous'}</Button></Link>
      </Col>
      <Col sm='6' xl='6'>
        <Link to={nextLink} className='m2no-decoration'><Button className='btn-block' outline>{nextItem === 'overview' ? 'Review >>' : 'Next >>'}</Button></Link>
      </Col>
    </Row>
  )

  if (props.next) {
    comp = (
      <Link to={nextLink} className='m2no-decoration'>
        <Button 
          className='btn-block next question-nav' 
          outline
        >
          {nextItem === props.itemNumber ? SUBMIT : 'v'}
        </Button>
      </Link>
    )
  } else if (props.prev) {
    comp = (
      <Link to={prevLink} className='m2no-decoration'>
        <Button className='btn-block prev question-nav' outline disabled={previousItem === props.itemNumber}>
          {previousItem === props.itemNumber ? '-' : '<'}
        </Button>
      </Link>
    )
  }

  if (props.next) {
    const text = nextItem === props.itemNumber ? SUBMIT : '>'
    comp = (
      <Button
        className='btn-block next question-nav'
        outline
        onClick={() => props.handleChangeItem(nextItem, text === '>' ? 'next' : 'submit')}
        disabled={nextItem === 'overview'}
      >
        {nextItem === props.itemNumber ? SUBMIT : (nextItem === 'overview' ? '|' : '>')}
      </Button>
    )
  }
  if (props.prev) {
    let text = previousItem === props.itemNumber || previousItem === 'overview' ? '|' : '<'
    comp = (
      <Button 
        className='btn-block prev question-nav' 
        outline 
        onClick={() => props.handleChangeItem(previousItem, 'prev')}
        disabled={text === '|'}
      >
        {text}
      </Button>
    )
  }

  return (
    <div>{comp}</div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTest/ItemBasicNavMath.js